import React from 'react';
import './Callout.scss';

interface CalloutProps {
  variant: 'info' | 'warning' | 'success' | 'error';
  size?: 'default' | 'small' | 'compact';
  icon?: React.ReactNode;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}

const Callout = ({
  variant,
  size = 'default',
  icon,
  title,
  subtitle,
  children,
  className = '',
}: CalloutProps) => {
  const sizeClass: string = size === 'default' ? '' : `callout-${size}`;

  const classes: string = ['callout', `callout-${variant}`, sizeClass, className]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes}>
      <div className="callout-content">
        {icon && <span className="callout-icon">{icon}</span>}
        <div className="callout-text">
          <p className="callout-title">{title}</p>
          {subtitle && <p className="callout-subtitle">{subtitle}</p>}
          {children && <div className="callout-children">{children}</div>}
        </div>
      </div>
    </div>
  );
};

export default Callout;
